import api, { handleResponse, handleError } from './api';

const linkPreviewService = {
  async preview(url) {
    try {
      return handleResponse(await api.get('/link-previews', { params: { url } }));
    } catch (e) { return handleError(e); }
  },
};

export default linkPreviewService;
